export const clearCache = async () => {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
    // Clear application cache
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(reg => reg.unregister()));
    }
  }
};

export const checkAndUpdateVersion = async () => {
  try {
    // Use no-cache headers to always fetch fresh version
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    });
    
    const { version: currentVersion, hash } = await response.json();
    const storedVersion = localStorage.getItem('appVersion');
    const storedHash = localStorage.getItem('appHash');

    if (!storedVersion || !storedHash || 
        storedVersion !== currentVersion || 
        storedHash !== hash) {
      await clearCache();
      localStorage.setItem('appVersion', currentVersion);
      localStorage.setItem('appHash', hash);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Version check failed:', error);
    return false;
  }
};
